module.exports = __webpack_public_path__ + "img/complete-form.b587c945.png";